import React, { useState, useEffect } from "react";
import "../../App.css"; // Import global styles
import { FaTwitter, FaLink, FaTimes } from "react-icons/fa";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import WebsiteLogo from "../../images/WebsiteLogo_1.png"; // Import the UrVote logo
import Comments from "./comments"; // Import Comments.jsx for UrVote content

const CommunityDiscussion = () => {
  const [tabs, setTabs] = useState(["UrVote", "Other Social Media"]); // Updated tab name
  const [activeTab, setActiveTab] = useState("UrVote"); // Track the active tab

  const [isLaptop, setIsLaptop] = useState(window.innerWidth > 1024); // Detect laptop or phone
  const [twitterHandle, setTwitterHandle] = useState(""); // User input for handle
  const [currentHandle, setCurrentHandle] = useState(""); // Submitted handle

  useEffect(() => {
    const handleResize = () => {
      setIsLaptop(window.innerWidth > 1024); // Update device type dynamically
    };

    window.addEventListener("resize", handleResize); // Listen for resize events
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup event listener
    };
  }, []);

  const socialMedia = {
    Twitter: {
      icon: <FaTwitter style={{ color: "#1DA1F2" }} />,
      link: "https://twitter.com",
    },
    UrVote: {
      icon: (
        <img
          src={WebsiteLogo}
          alt="UrVote"
          style={{ width: "24px", height: "24px" }}
        />
      ),
      link: "https://urvote.example.com", // Replace with the correct URL for UrVote
    },
  };

  const handleAddTab = (name) => {
    if (!tabs.includes(name)) {
      if (name === "Twitter") {
        // Insert Twitter tab before "Other Social Media" tab
        const updatedTabs = ["UrVote", "Twitter", "Other Social Media"];
        setTabs(updatedTabs);
      } else {
        setTabs((prevTabs) => [...prevTabs, name]);
      }
    }
    setActiveTab(name);
  };

  const handleRemoveTab = (name) => {
    setTabs((prevTabs) => prevTabs.filter((tab) => tab !== name));
    setActiveTab("Other Social Media"); // Reset to "Other Social Media" if the active tab is removed
  };

  return (
    <div className="community-container" style={{ width: "100%" }}>
      <div
        className="tabs-container"
        style={{ width: "100%", textAlign: "left" }}
      >
        <div
          className="tab-navigation"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            borderBottom: "2px solid #ccc",
            marginBottom: "5px",
            width: "100%",
            gap: "10px",
            flexWrap: "wrap", // Ensure tabs wrap on smaller devices
          }}
        >
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-button ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 10px",
                border: "none",
                backgroundColor: activeTab === tab ? "#007bff" : "#f0f0f0",
                color: activeTab === tab ? "#fff" : "#000",
                cursor: "pointer",
                fontWeight: activeTab === tab ? "bold" : "normal",
                gap: "10px",
                width: isLaptop ? "100%" : "50%", // Adjust width based on device type
              }}
            >
              <span>{tab}</span>
              {tab !== "Other Social Media" && tab !== "UrVote" && (
                <FaTimes
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveTab(tab);
                  }}
                  style={{
                    fontSize: "14px",
                    cursor: "pointer",
                    color: activeTab === tab ? "#fff" : "#999",
                  }}
                />
              )}
            </button>
          ))}
        </div>
      </div>

      <div className="tab-content" style={{ width: "100%", padding: "10px" }}>
        {activeTab === "Other Social Media" && (
          <div
            className="discussion-content"
            style={{
              borderRadius: "10px",
              padding: "10px",
              width: "100%",
              boxShadow: "none",
              backgroundColor: "transparent",
            }}
          >
            <div
              className="popup"
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                borderRadius: "10px",
                boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
                width: "300px",
                margin: "0 auto",
              }}
            >
              <h5 style={{ marginBottom: "15px", color: "black" }}>
                Connect to
              </h5>
              <div
                className="social-icons"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  fontSize: "24px",
                  color: "#555",
                  marginBottom: "20px",
                }}
              >
                <span
                  onClick={() => handleAddTab("UrVote")}
                  style={{ cursor: "pointer" }}
                >
                  {socialMedia.UrVote.icon}
                </span>
                <span
                  onClick={() => handleAddTab("Twitter")}
                  style={{ cursor: "pointer" }}
                >
                  {socialMedia.Twitter.icon}
                </span>
              </div>
            </div>
          </div>
        )}

        {activeTab === "UrVote" && (
          <div
            className="white-box-content"
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
              padding: "5px",
              width: "100%",
            }}
          >
            <Comments />
          </div>
        )}

        {activeTab === "Twitter" && (
          <div style={{ padding: "20px" }}>
            <div style={{ display: "flex", marginBottom: "20px" }}>
              <input
                type="text"
                value={twitterHandle}
                onChange={(e) => setTwitterHandle(e.target.value)}
                placeholder="Enter Twitter handle (e.g., @EqualOpp4All)"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
              <button
                onClick={() => {
                  if (twitterHandle.startsWith("@")) {
                    setCurrentHandle(twitterHandle.slice(1));
                  } else {
                    setCurrentHandle(twitterHandle);
                  }
                }}
                style={{
                  marginLeft: "10px",
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                View Timeline
              </button>
            </div>

            {currentHandle && (
              <div style={{ height: "800px", width: "100%" }}>
                <h4>Timeline for @{currentHandle}</h4>
                <TwitterTimelineEmbed
                  sourceType="profile"
                  screenName={currentHandle}
                  options={{ height: 800 }}
                  theme="light"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CommunityDiscussion;
